module.exports = __webpack_public_path__ + "static/media/S4N5.4418e7a1.svg";